import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { BiEdit } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineRight } from "react-icons/ai";

const Contact = () => {
  const [rows, setRows] = useState([]); // [] so DataTable never gets undefined
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.Id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => row.FirstName + row.LastName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      sortable: true,
    },
    {
      name: "PhoneNumber",
      sortable: true,
      selector: (row) => row.PhoneNumber,
    },
    {
      name: "Contact Date",
      sortable: true,
      selector: (row) => row.CreatedDate,
    },
    {
      name: "Options",
      width: "200px",
      cell: (row) => (
        <div className="d-flex">
          <NavLink
            to={`/admin/rasha/Contact/${row.Id}`} // keep casing consistent everywhere
            className="btn btn-outline-secondary btn-sm"
          >
            <BiEdit />
          </NavLink>
        </div>
      ),
    },
  ];

  async function getContact() {
    setLoading(true);
    try {
      const res = await fetch(`${Variables.API_URL}Rasha/Contact/Get`);
      if (!res.ok) throw new Error("Did not receive expected data");
      const listItems = await res.json();
      const offset = new Date().getTimezoneOffset(); // in minutes

      const formattedItems = listItems.map((item) => {
        const utcDate = new Date(item.CreatedDate);

        // adjust by offset (offset is minutes behind UTC, so we invert it)
        const localDate = new Date(utcDate.getTime() - offset * 60000);

        return {
          ...item,
          CreatedDate: localDate.toLocaleString(), // or keep as Date object
        };
      });

      setRows(formattedItems);
    } catch (e) {
      toast.error("Failed to load Contact");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getContact();
  }, []);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Contact</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>List Contact</li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="portalTable">
                  <DataTable
                    keyField="Id"
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    dense
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};

export default Contact;
